module.exports = __webpack_public_path__ + "media/images/version_merge/visa_logo-24530b103464a209b9992aa9a227009f.png";